export default "/images/vendor/flag-icon-css/flags/1x1/bb.svg?17738ccf41cecf9d38bae410178bc122";